import S, { DataSignal } from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import { ValidationWatcher, Errors } from 'lib/validationWatcher';
import { Entrypoints } from 'core/app/entrypoints';

import { RestoreAccountRequestData } from 'data/models/Accounts';
import { UserSummary, UserSummaryData } from 'data/models/UserSummary';

import { HandleAlreadyActive } from 'portcall/acceptinvitation/invitationerrors';
import { Login, LoginParams } from 'portcall/login/model';

export interface RestoreAccountParams {
    invitationId : number;
    token : string;
}

export function RestoreAccount(
    ajax : IAjax,
    entrypoints : Entrypoints,
    user : DataSignal<UserSummary | null>,
    loginModel : (params : LoginParams) => Login,
    { invitationId, token } : RestoreAccountParams
) {
    const client = ajax.Url<RestoreAccountRequestData, UserSummaryData>(entrypoints.RestoreAccount),
        validation = ValidationWatcher(client),
        request = client.Post({
            InvitationId: invitationId,
            Token: token
        }),
        showLogin = S.data(false),
        login = S(() => showLogin() ? loginModel({ useLandingPage: true, onHidePopup: () => showLogin(false) }) : null);

    // if get AlreadyActive error from server, update user object
    S(() => HandleAlreadyActive(validation(), user));

    // if account restoration succeeds, update user object
    request.then(userSummary => user(new UserSummary(userSummary)));

    return {
        Validation: validation,
        Request: request,
        ShowLogin: showLogin,
        Login: login,
        User: user
    };


}
export type RestoreAccount = ReturnType<typeof RestoreAccount>;


// WEBPACK FOOTER //
// ./apps/portcall/restoreaccount/model.ts